import { action } from 'typesafe-actions';

// Types
import { SynopticInterface, SynopticTypes } from './types';

// Monitoring List
export const listSynopticRequest = (payload: object) =>
  action(SynopticTypes.LIST_SYNOPTIC_REQUEST, payload);

export const listSynopticSuccess = (payload: {
  monitoringList: SynopticInterface[];
  totalCount: number;
}) => action(SynopticTypes.LIST_SYNOPTIC_SUCCESS, payload);

export const listSynopticFailure = () =>
  action(SynopticTypes.LIST_SYNOPTIC_FAILURE);
